import { defineComponent as _defineComponent } from 'vue';
import { SButton } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import mainImg from '@/assets/images/index/main-img.png';
import mainImg2x from '@/assets/images/index/main-img@x2.png';
import ResponsivePicture from '@/shared/ui/ResponsivePicture.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingHeroSection',
  props: {
    title: null,
    text: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingHeroSection'
    });
    return {
      __sfc: true,
      SButton: SButton,
      mainImg: mainImg,
      mainImg2x: mainImg2x,
      ResponsivePicture: ResponsivePicture
    };
  }
});